import React, {useState, useEffect} from 'react';
import { getAdvertisementLineData } from './requests';
import './index.css';

const AdvertisementLine = () => {
    const [src, setSrc] = useState(null);
    const [active, setActive] = useState(null);
    const [link, setLink] = useState(null);

    const processingRequest = async () => {
        const data = (await getAdvertisementLineData()).data;
        console.log("data", data)
        setSrc(data.src);
        setActive(data.active);
        setLink(data.link)
    }

    useEffect(() => {
        processingRequest()
    }, []);
    return (
        <div className="advertisement-line-container">
            {active && (
                <a href={link} style={{backgroundImage: `url(${src})`}}>
                    {/* <img src={src} /> */}
                </a>
            )}
        </div>
    )
}

export default AdvertisementLine;